import { XIcon } from 'lucide-react';
import { Activity } from 'react';

import { Badge, Typography } from '@crossnokaye/ux-common';
import {
  Button,
  Header,
  HeaderIcon,
  HeaderRightActions,
  HeaderTitle,
  HeaderTitleGroup,
} from '@crossnokaye/ux-common/ckds';

interface EquipmentBulkEditHeaderProps {
  deviceCount: number;
  isPushOutOpen: boolean;
  onClose: () => void;
  title: string;
}

export const EquipmentBulkEditHeader = ({
  deviceCount,
  isPushOutOpen,
  onClose,
  title,
}: EquipmentBulkEditHeaderProps) => {
  return (
    <Header align="center" className="min-h-[3rem] px-2 py-0">
      <HeaderIcon>
        <div className="flex h-full items-center">
          {/* TODO: Update component variant or use new badge component based on PM feedback */}
          <Badge variant="light" className="bg-foreground text-secondary">
            {deviceCount}
          </Badge>
        </div>
      </HeaderIcon>
      <HeaderTitleGroup>
        <HeaderTitle>
          <div className="flex h-full items-center">
            <Typography variant="body" className="text-primary uppercase leading-none">
              {title}
            </Typography>
          </div>
        </HeaderTitle>
      </HeaderTitleGroup>
      <Activity mode={isPushOutOpen ? 'hidden' : 'visible'}>
        <div className="flex h-full items-center">
          <HeaderRightActions>
            <Button variant="tier2" size="md" shape="circle" onClick={onClose}>
              <XIcon className="w-5 h-5" />
            </Button>
          </HeaderRightActions>
        </div>
      </Activity>
    </Header>
  );
};
